import RoleLogin from "@/components/feature/auth/RoleLogin";

export default function AdminGiris() {
  return <RoleLogin role="admin" />;
}